import { randomInRange } from "tsparticles-engine";

function updateColorValue(delta, colorValue, valueAnimation, max, decrease) {
  var _colorValue$maxLoops, _colorValue$loops, _colorValue$maxLoops2, _colorValue$delayTime, _colorValue$delayTime2, _colorValue$delayTime3, _colorValue$delayTime4, _colorValue$velocity, _colorValue$decay;

  if (!colorValue || !valueAnimation.enable || ((_colorValue$maxLoops = colorValue.maxLoops) !== null && _colorValue$maxLoops !== void 0 ? _colorValue$maxLoops : 0) > 0 && ((_colorValue$loops = colorValue.loops) !== null && _colorValue$loops !== void 0 ? _colorValue$loops : 0) > ((_colorValue$maxLoops2 = colorValue.maxLoops) !== null && _colorValue$maxLoops2 !== void 0 ? _colorValue$maxLoops2 : 0)) {
    return;
  }

  if (!colorValue.time) {
    colorValue.time = 0;
  }

  if (((_colorValue$delayTime = colorValue.delayTime) !== null && _colorValue$delayTime !== void 0 ? _colorValue$delayTime : 0) > 0 && colorValue.time < ((_colorValue$delayTime2 = colorValue.delayTime) !== null && _colorValue$delayTime2 !== void 0 ? _colorValue$delayTime2 : 0)) {
    colorValue.time += delta.value;
  }

  if (((_colorValue$delayTime3 = colorValue.delayTime) !== null && _colorValue$delayTime3 !== void 0 ? _colorValue$delayTime3 : 0) > 0 && colorValue.time < ((_colorValue$delayTime4 = colorValue.delayTime) !== null && _colorValue$delayTime4 !== void 0 ? _colorValue$delayTime4 : 0)) {
    return;
  }

  var offset = randomInRange(valueAnimation.offset),
      velocity = ((_colorValue$velocity = colorValue.velocity) !== null && _colorValue$velocity !== void 0 ? _colorValue$velocity : 0) * delta.factor + offset * 3.6,
      decay = (_colorValue$decay = colorValue.decay) !== null && _colorValue$decay !== void 0 ? _colorValue$decay : 1;

  if (!decrease || colorValue.status === "increasing") {
    colorValue.value += velocity;

    if (colorValue.value > max) {
      if (!colorValue.loops) {
        colorValue.loops = 0;
      }

      colorValue.loops++;

      if (decrease) {
        colorValue.status = "decreasing";
        colorValue.value -= colorValue.value % max;
      }
    }
  } else {
    colorValue.value -= velocity;

    if (colorValue.value < 0) {
      if (!colorValue.loops) {
        colorValue.loops = 0;
      }

      colorValue.loops++;
      colorValue.status = "increasing";
      colorValue.value += colorValue.value;
    }
  }

  if (colorValue.velocity && decay !== 1) {
    colorValue.velocity *= decay;
  }

  if (colorValue.value > max) {
    colorValue.value %= max;
  }
}

export function updateColor(particle, delta) {
  var _particle$options$col = particle.options.color.animation,
      hAnimation = _particle$options$col.h,
      sAnimation = _particle$options$col.s,
      lAnimation = _particle$options$col.l,
      color = particle.color;

  if (!color) {
    return;
  }

  var h = color.h,
      s = color.s,
      l = color.l;

  if (h) {
    updateColorValue(delta, h, hAnimation, 360, false);
  }

  if (s) {
    updateColorValue(delta, s, sAnimation, 100, true);
  }

  if (l) {
    updateColorValue(delta, l, lAnimation, 100, true);
  }
}